import type { operations } from '@/types/schemas/api.main';
import { GET, setParams } from '../../_http';

type controller = operations['PublicReferralTypesListReferralTypesController_get'];
type ListReferralTypesResponse = controller['responses']['200']['content']['application/json'];

export type ListReferralTypesQuery = {
  displayContext?: 'broker' | 'customer';
  originType?: string;
};

const _listReferralTypes = GET(
  '/public/referral-types/list-referral-types',
  setParams<Partial<ListReferralTypesQuery>>,
)<ListReferralTypesResponse>;

export const listReferralTypes = (params?: Partial<ListReferralTypesQuery>) => _listReferralTypes(params ?? {});
